// extracted by mini-css-extract-plugin
module.exports = {"brand":"style_brand__1omIJ","collapsed":"style_collapsed__k50IJ","middle":"style_middle__fTkVE","large":"style_large__IoaxL"};